export default __webpack_public_path__ + "static/media/Neom.95d4c17b.jpeg";